
<template>
    <div class="tabla-dif">
        <vs-table striped>
            <template #thead>
            <vs-tr>
                <vs-th style="width: 30%;">
                    Alumno
                </vs-th>
                <vs-th style="width: 30%;">
                    Académico
                </vs-th>
                <vs-th style="width: 30%;">
                    Finanzas
                </vs-th>
                <vs-th>
                    Acciones
                </vs-th>
            </vs-tr>
            </template>
            <template #tbody>
            <vs-tr
                :key="i"
                v-for="(tr, i) in $vs.getSearch(users, search)"
                :data="tr"
            >
                <vs-td style="vertical-align: top">
                    <vs-row>
                        <vs-col w="2">
                            <vs-avatar circle class="m-auto">
                                <img :src="'/api/personas/' + window.atob(tr.estadoCuenta) + '/avatar'"  alt="">
                            </vs-avatar>
                        </vs-col>
                        <vs-col w="10" class="pl-2">
                            <p class="mb-1"><strong>{{ tr.nombre }}</strong></p>
                            <p class="mb-0"><small>MATRÍCULA</small></p>
                            <p class="mb-0"><strong>{{ tr.matricula }}</strong></p>
                        </vs-col>
                    </vs-row>
                </vs-td>
                <vs-td style="vertical-align: top">
                    <p class="mb-0 text-uppercase"><small>Ciclo escolar</small></p>
                    <p class="mb-1"><strong>{{ tr.cicloEscolar }}</strong></p>
                    <p class="mb-0 text-uppercase"><small>Programa</small></p>
                    <p class="mb-1"><strong>{{ tr.programa }}</strong></p>
                    <p class="mb-0 text-uppercase"><small>Grupo</small></p>
                    <p class="mb-1"><strong>{{ tr.grupo_administrativo }}</strong></p>
                    <p class="mb-0 text-uppercase"><small>Grado</small></p>
                    <p class="mb-1"><strong>{{ tr.grado }}</strong></p>
                    <p class="mb-0 text-uppercase"><small>Inscripción académica</small></p>
                    <md-chip class="mini-chip text-uppercase" :class="tr.inscripcion_academica == 'si' ? 'col-green' : 'col-yellow'"><strong> {{ tr.inscripcion_academica }} </strong></md-chip>
                </vs-td>
                <vs-td style="vertical-align: top">
                    <p class="mb-0 text-uppercase"><small>Cartera vencida en ciclos anteriores</small></p>
                    <md-chip class="mini-chip text-uppercase col-red"><strong> {{ tr.cartera_vencida_ciclos_anteriores | currency }} </strong></md-chip>
                    <p class="mt-2 mb-0 text-uppercase"><small>Monto pagado</small></p>
                    <md-chip class="mini-chip text-uppercase col-green"><strong> {{ tr.monto_pagado | currency }} </strong></md-chip>
                </vs-td>
                <vs-td style="vertical-align: top">
                    <md-menu md-size="small" :md-offset-x="-150">
                        <md-button class="md-icon-button" md-menu-trigger>
                            <i class="fas fa-ellipsis-v"></i>
                        </md-button>

                        <md-menu-content>
                            <md-menu-item
                            @click="activePago =! activePago, personaId = window.atob(tr.estadoCuenta), rowSaldo = tr">
                                Registra saldo inicial
                            </md-menu-item>
                            <md-menu-item @click="activeCarteraVencida =! activeCarteraVencida, personaId = window.atob(tr.estadoCuenta), row = tr">
                                Registrar cartera vencida de SIM
                            </md-menu-item>
                            <md-menu-item style="border-top: 1px solid gray;"  target="_blank"
                            :href="'/estado-de-cuenta/' + window.atob(tr.estadoCuenta) + '/gestion?institucion_id=' + institucion + '&ciclo_escolar_id=' + cicloEscolar">
                                Gestión finanzas
                            </md-menu-item>
                        </md-menu-content>
                    </md-menu>
                </vs-td>
            </vs-tr>
            </template>
            <template #notFound>
                Sin información
            </template>
        </vs-table>
        <registrar-pago v-model="activePago" :filtros="filtros" :tipo="'abierto'" :personaId="personaId" :rowSaldo="rowSaldo" @refreshTable="getRegresh"></registrar-pago>
        <registrar-cartera-vencida v-model="activeCarteraVencida" :filtros="filtros" :row="row" :personaId="personaId"  @refreshTable="getRegresh"></registrar-cartera-vencida>
    </div>
</template>
<script>
import { dragscroll } from 'vue-dragscroll'
import RegistrarPago from './modal/registrar-pagos.vue'
import RegistrarCarteraVencida from './modal/registrar-cartera-vencida.vue'
export default {
    props: [
        'users',
        'filtros',
        'institucion',
        'cicloEscolar'
    ],
    data:() => ({
        search: '',
        activePago: false,
        activeCarteraVencida: false,
        personaId: '',
        row: [],
        rowSaldo: []
    }),
    directives: {
       'dragscroll': dragscroll
    },
    components:{
        RegistrarPago,
        RegistrarCarteraVencida
    },
    methods:{
        getRegresh(){
      		this.$emit('refreshTable',true)
        }
    }
}
</script>
<style scoped>
.vs-avatar img{
    object-fit: contain;
}
</style>

<style lang="scss" scoped>
    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }
    .vs-avatar img{
        object-fit:contain;
    }
</style>